'use client';

import { Link } from 'react-router-dom';
import styles from '../ProductDetail.module.css';

export function BondexSungerHubContent() {
  return (
    <div className={styles.seoWrap}>
      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Bondex Sünger Nedir?</h2>
        <p className={styles.seoText}>
          Bondex sünger, geri dönüştürülmüş poliüretan (PU) sünger parçalarının yüksek basınç altında
          sıkıştırılmasıyla üretilen, yüksek yoğunluklu bir ses yalıtım malzemesidir. Standart akustik
          süngerlerden farklı olarak sesi yalnızca emmekle kalmaz, aynı zamanda ses geçişini azaltmaya da
          yardımcı olur. Bu nedenle duvar, tavan, zemin, makine daireleri, jeneratör odaları ve ortak duvar
          uygulamalarında sıklıkla tercih edilir.
        </p>

        <h3 className={styles.seoSubtitle}>Bondex Süngerin Üretim Yapısı</h3>
        <p className={styles.seoText}>
          Üretimde kullanılan ham madde, fabrika artıkları ve geri dönüştürülmüş sünger parçacıklarıdır. Bu
          parçacıklar özel preslerde yüksek basınç ve ısı uygulanarak birbirine bağlanır; ortaya rebonded
          süngerpan adı verilen homojen, lifli ve sert bir levha çıkar. Echopan üretim hattında yoğunluk
          (DNS) değeri kontrollü tutulur; düşük yoğunluklu süngerpanlar kolay ezilir, yüksek yoğunluklu
          levhalar ise yıllarca formunu korur. Levha yüzeyi genelde düzgün kesilir, proje ölçüsüne göre
          plaka halinde sunulur.
        </p>
        <p className={styles.seoText}>
          Presleme sırasında parçacıklar arası bağlantı kimyasal yapıştırıcı veya ısı reaksiyonuyla sağlanır.
          Sonuçta elde edilen levha homojen bir görünüme sahiptir; içinde büyük boşluk veya yumuşak bölge
          kalmaz. Bu üretim yöntemi malzemenin her noktasında benzer yoğunluk ve performans sunmasını sağlar.
          Kesim sonrası levha kenarları düzgün bırakılır; karkas içine yerleştirmede boşluk bırakmamak için
          proje ölçüsüne göre önceden kesim yapılabilir.
        </p>

        <h3 className={styles.seoSubtitle}>Bondex Süngerin Ses Yalıtımındaki Görevi</h3>
        <p className={styles.seoText}>
          Ses yalıtımında bondex sünger iki mekanizmayla çalışır. Birincisi, hava kaynaklı ses dalgalarının
          lifli yapı içinde sönümlenmesidir; ikincisi, yapı elemanlarına iletilen titreşimin elastik gövdede
          dağıtılmasıdır. Tek başına duvar arasına konan bondex sünger, komşu daireden gelen konuşma sesini
          tamamen kesmez; ancak darbe sesi, makine titreşimi ve orta frekanslı gürültüde belirgin fark
          yaratır. Hava yolu sesinde daha güçlü sonuç için{' '}
          <Link to="/bariyerli-bondex-sunger" rel="follow">
            Bariyerli Bondex Sünger
          </Link>{' '}
          gibi bariyer katmanlı modeller değerlendirilir.
        </p>
        <p className={styles.seoText}>
          Bondex sünger ses yalıtım süngeri olarak sınıflandırılır; yankı süngeri değildir. Duvar karkası
          içinde alçıpan ile birlikte kullanıldığında sistem toplamında izolasyon artar. Karkas profili ile
          levha arasında doğrudan sert temas titreşim köprüsü oluşturur; bu nedenle profil ile levha arasına
          ince sünger şeridi veya conta yerleştirmek performansı yükseltir. Ses yalıtımında en kritik nokta
          sürekliliktir: levha ek yerleri, priz boşlukları ve kapı çevresi kapatılmadan tek başına levha
          yeterli sonuç vermez.
        </p>

        <h3 className={styles.seoSubtitle}>Akustik Sünger ile Bondex Sünger Arasındaki Farklar</h3>
        <p className={styles.seoText}>
          Akustik sünger genelde açık hücreli, düşük yoğunluklu ve yankı kontrolü için tasarlanır; oda içindeki
          yansımayı azaltır, duvar arkasından ses geçişini engellemez. Bondex sünger ise kapalı hücre ağırlıklı,
          yüksek DNS değerli ve yapısal ses yalıtımına yöneliktir. Stüdyoda yankıyı düşürmek için akustik sünger
          panel, komşu odaya ses gitmesini engellemek için bondex sünger veya bariyerli bondex tercih edilir.
          İki malzeme birbirinin yerine değil, farklı aşamalarda kullanılır; bazı projelerde önce bondex katmanı,
          üzerine akustik kaplama uygulanır.
        </p>
        <p className={styles.seoText}>
          Yoğunluk farkı belirleyicidir: akustik sünger 20-60 kg/m³ aralığında çalışırken bondex sünger 100 kg/m³
          üzerinde üretilir. Görünüm olarak bondex sünger daha sert ve kompakt; akustik sünger yumuşak ve gözeneklidir.
          Fiyat karşılaştırmasında da farklı segmentlerde yer alırlar. Yanlış ürün seçimi en sık akustik süngeri
          duvar arkasına koyarak komşu sesini kesmeye çalışmaktır; bu uygulama beklenen sonucu vermez.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Bondex Sünger Özellikleri</h2>

        <h3 className={styles.seoSubtitle}>Yüksek Yoğunluklu Yapısı</h3>
        <p className={styles.seoText}>
          Bondex süngerin en belirgin özelliği yoğunluğudur. Tipik DNS aralığı 100 ile 200 kg/m³ arasında
          değişir; bu değer standart süngerden kat be kat yüksektir. Yoğun yapı, ses dalgasının malzeme
          içinde daha uzun yol almasını sağlar ve enerji kaybını artırır. Aynı zamanda mekanik dayanım sunar:
          şap altında, makine altında veya duvar karkası içinde ezilmeden çalışır. Echopan stoklarında farklı
          DNS seçenekleri proje ihtiyacına göre belirlenir.
        </p>
        <p className={styles.seoText}>
          Yoğunluk arttıkça levha sertleşir ve ağırlaşır. Duvar karkasında hafif DNS levha yeterli olabilir;
          şap altında ve makine altında yüksek DNS şarttır. Aynı kalınlıkta 150 kg/m³ levha, 120 kg/m³
          levhaya göre daha az sıkışır ve uzun vadede performans kaybı yaşamaz. Yoğunluk seçimi yapılırken
          yalnızca ses performansı değil, mekanik yük de hesaba katılmalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Darbe ve Titreşim Azaltma Performansı</h3>
        <p className={styles.seoText}>
          Katlar arası ayak sesi, düşen eşya gürültüsü ve makine kaynaklı titreşim yapı elemanları üzerinden
          iletilir. Bondex sünger bu darbe enerjisini elastik deformasyonla sönümler; özellikle zemin altı
          şap detaylarında ve jeneratör altı uygulamalarda etkilidir. İnce detay gerektiren yerlerde{' '}
          <Link to="/bondex-sunger-10mm" rel="follow">
            Bondex Sünger 10mm
          </Link>{' '}
          kullanılırken, daha yoğun darbe yükünde kalın modeller tercih edilir. Titreşim izolasyonu tek başına
          yeterli olmadığında elastik ayak veya süspansiyon sistemiyle birlikte planlanmalıdır.
        </p>
        <p className={styles.seoText}>
          Darbe sesi yapısal olarak iletildiği için hafif malzemelerle engellenemez. Beton döşeme doğrudan
          betonarme kirişe bağlıysa titreşim kolayca alt kata geçer. Bondex sünger araya girdiğinde darbe
          enerjisi elastik katmanda dağılır ve yapıya iletilen kısım azalır. Zemin uygulamasında levha
          tüm alanı kaplamalıdır; küçük bir boşluk bile darbe köprüsü oluşturur. Makine altında levha
          makine ağırlığına göre seçilmeli; düşük DNS levha ağır makine altında zamanla sıkışır.
        </p>

        <h3 className={styles.seoSubtitle}>Farklı Kalınlık ve DNS Seçenekleri</h3>
        <p className={styles.seoText}>
          Bondex sünger 10, 20, 30, 40 ve 50 mm kalınlıklarda üretilir. Kalınlık arttıkça sönümleme kapasitesi
          yükselir; ancak her projede en kalın levha en doğru seçim değildir. DNS değeri de performansı
          belirler: aynı kalınlıkta yüksek DNS levha daha sert ve daha dayanıklıdır. Echopan teknik ekibi,
          uygulama alanına göre kalınlık ve yoğunluk kombinasyonunu önerir. Dengeli çözüm arayanlar için{' '}
          <Link to="/bondex-sunger-20mm" rel="follow">
            Bondex Sünger 20mm
          </Link>{' '}
          en sık tercih edilen ara kalınlıktır.
        </p>

        <h3 className={styles.seoSubtitle}>Uzun Ömürlü Kullanım Avantajları</h3>
        <p className={styles.seoText}>
          Doğru montajla bondex sünger on yılı aşan süre boyunca performansını korur. Nemli ortamlarda küf
          oluşumuna karşı dirençlidir; kapalı hücre yapısı su emmez. Kimyasal stabilitesi sayesinde şap,
          alçıpan veya kaplama altında çökme yapmaz. Geri dönüştürülmüş içerik kullanımı çevresel açıdan da
          avantaj sağlar. Uzun ömür, özellikle ticari ve endüstriyel projelerde toplam sahip olma maliyetini
          düşürür.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Bondex Sünger Nerelerde Kullanılır?</h2>

        <h3 className={styles.seoSubtitle}>Ortak Duvar Ses Yalıtımı</h3>
        <p className={styles.seoText}>
          Apartman ve iş merkezlerinde ortak duvarlardan geçen ses en yaygın şikayettir. Bondex sünger duvar
          karkası içine yerleştirilerek veya doğrudan beton yüzeye yapıştırılarak kullanılır. Konuşma sesi
          ağırlıklı problemlerde bariyer katmanı şart olabilir; darbe ve hafif gürültüde standart bondex
          yeterli kalabilir. Duvarın tek tarafına uygulama kısmi fayda sağlar; yüksek izolasyon için her iki
          yüzeyin de kaplanması veya{' '}
          <Link to="/bariyerli-bondex-sunger-33mm" rel="follow">
            Bariyerli Bondex Sünger 33mm
          </Link>{' '}
          gibi kompozit levhalar tercih edilir.
        </p>
        <p className={styles.seoText}>
          İnce bölme duvarlarda profil kalınlığı sınırlıdır; bu durumda ince bariyerli modeller veya doğrudan
          yapıştırma yöntemi değerlendirilir. Betonarme ortak duvarlarda karkas sistemi tercih edilir; bondex
          sünger karkas boşluğunu doldurur, üzerine alçıpan gelir. Priz ve tesisat kutusu çevresi ses
          sızdıran en zayıf noktalardır; bu boşluklar akustik mastik ve bantla kapatılmalıdır. Duvar tabanı
          ve tavan birleşiminde levha sürekliliği sağlanmazsa ses köşeden dolaşarak geçer.
        </p>

        <h3 className={styles.seoSubtitle}>Tavan ve Kat Arası Ses İzolasyonu</h3>
        <p className={styles.seoText}>
          Üst kattan gelen ayak sesi ve düşen cisim gürültüsü tavan altı uygulamalarla azaltılır. Bondex
          sünger tavan karkası arasına konur; üzerine alçıpan veya asma tavan sistemi gelir. Kalınlık seçimi
          tavan yüksekliği ve hedef izolasyon seviyesine bağlıdır. Orta düzey ihtiyaçlarda{' '}
          <Link to="/bondex-sunger-30mm" rel="follow">
            Bondex Sünger 30mm
          </Link>{' '}
          yaygın kullanılır. Tavan birleşim noktalarında süreklilik sağlanmazsa ses köprüsü oluşur; levha
          duvar yüzeyine kadar uzatılmalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Jeneratör ve Makine Daireleri</h3>
        <p className={styles.seoText}>
          Jeneratör, kompresör, klima santrali ve asansör makine odaları hem hava kaynaklı gürültü hem de
          yapısal titreşim üretir. Bondex sünger zemin altında şap detayında, duvar karkasında ve makine
          altında tampon katman olarak kullanılır. Yüksek ses seviyelerinde{' '}
          <Link to="/bondex-sunger-50mm" rel="follow">
            Bondex Sünger 50mm
          </Link>{' '}
          veya bariyerli modeller birlikte değerlendirilir. Makine titreşimini yapıya iletmemek için elastik
          montaj elemanları bondex katmanıyla birlikte planlanmalıdır.
        </p>
        <p className={styles.seoText}>
          Makine dairesi uygulamasında hem hava yolu hem darbe yolu sesi aynı anda ele alınmalıdır. Duvar
          ve tavan bariyerli bondex ile kaplanırken zemin bondex sünger şap altında uygulanır. Havalandırma
          kanalı ve kapı boşluğu ses sızdıran kritik noktalardır; levha uygulaması tek başına yeterli değildir.
          Yangın güvenliği gerektiren tesislerde malzeme sınıfı proje onayına göre belirlenir; Echopan teknik
          ekibi bu konuda bilgi verir.
        </p>

        <h3 className={styles.seoSubtitle}>Müzik Odaları ve Stüdyolar</h3>
        <p className={styles.seoText}>
          Ev stüdyosu, prova odası ve kayıt hacimlerinde bondex sünger yapısal izolasyonun temel katmanıdır.
          Dışarıdan gelen gürültüyü kesmek ve içerideki yüksek sesin komşuya gitmesini sınırlamak için duvar,
          tavan ve zeminde uygulanır. Yankı kontrolü için üzerine akustik panel eklenebilir. Profesyonel
          stüdyolarda{' '}
          <Link to="/bariyerli-bondex-sunger-43mm" rel="follow">
            Bariyerli Bondex Sünger 43mm
          </Link>{' '}
          veya{' '}
          <Link to="/cift-bariyerli-bondex-sunger" rel="follow">
            Çift Bariyerli Bondex
          </Link>{' '}
          ile çok katmanlı sistemler kurulur.
        </p>

        <h3 className={styles.seoSubtitle}>Ofis ve Toplantı Odaları</h3>
        <p className={styles.seoText}>
          Açık ofislerde konuşma gürültüsü, toplantı odalarında mahremiyet ihtiyacı bondex sünger
          uygulamalarını gündeme getirir. Bölme duvar karkası içine yerleştirilen levha, sesin yan
          bölmelere taşınmasını azaltır. Cam bölmeli ofislerde bondex tek başına yeterli olmayabilir; cam
          yüzey ve tavan detayları da ele alınmalıdır. Hızlı uygulama gerektiren ofis projelerinde{' '}
          <Link to="/bondex-sunger-20mm" rel="follow">
            Bondex Sünger 20mm
          </Link>{' '}
          pratik bir başlangıç noktasıdır.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Bariyerli Bondex Sünger Nedir?</h2>
        <p className={styles.seoText}>
          Bariyerli bondex sünger, rebonded süngerpan gövdesine ağır ve esnek bir ses bariyeri katmanının
          lamine edilmesiyle oluşan kompozit bir yalıtım levhasıdır. Standart bondex sünger darbe ve
          titreşimde güçlüyken, bariyerli model hava kaynaklı ses geçişinde belirgin üstünlük sağlar. İki
          malzeme tek levha halinde sunulduğu için montaj süresi kısalır ve katman uyumu garanti altına alınır.
        </p>

        <h3 className={styles.seoSubtitle}>Ses Bariyeri ile Güçlendirilmiş Yapı</h3>
        <p className={styles.seoText}>
          Bariyer katmanı yüksek kütleli, esnek bir malzemeden oluşur; ses dalgasının geçişini kütle etkisiyle
          zorlaştırır. Bondex sünger kısmı bariyerin arkasında veya önünde titreşimi sönümler. Montajda bariyer
          yüzeyi ses kaynağına dönük olmalıdır; ters yerleştirme performansı düşürür. Echopan bariyerli serisi
          23, 33, 43 ve 53 mm toplam kalınlıkta üretilir.
        </p>
        <p className={styles.seoText}>
          Kompozit yapıda bariyer ve sünger fabrikada birbirine lamine edilir; sahada ayrı katman birleştirmeye
          gerek kalmaz. Bu hem montaj hatasını azaltır hem de katmanlar arası hava boşluğu riskini ortadan
          kaldırır. Bariyer ağırlığı kg/m² cinsinden ifade edilir; ağırlık arttıkça hava yolu sesinde iyileşme
          görülür. Bariyerli levha kesiminde bariyer yüzeyi bıçakla delinmemeli; kesim sonrası ek yerleri
          akustik bantla kapatılmalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Bariyerli Bondex Süngerin Avantajları</h3>
        <p className={styles.seoText}>
          Tek levha ile hem sönümleme hem bariyer etkisi elde edilir; ayrı ayrı malzeme birleştirmeye gerek
          kalmaz. Duvar ve kapı uygulamalarında ince detayda bile yüksek izolasyon sağlar. Komşu daireden
          gelen TV, konuşma ve müzik sesinde standart bondexe göre belirgin fark yaratır.{' '}
          <Link to="/bariyerli-bondex-sunger" rel="follow">
            Bariyerli Bondex Sünger
          </Link>{' '}
          sayfasından kalınlık seçeneklerini inceleyebilirsiniz.
        </p>

        <h3 className={styles.seoSubtitle}>Hangi Alanlarda Tercih Edilmelidir?</h3>
        <p className={styles.seoText}>
          Komşu duvar ses geçişi, ev sinema odası, kayıt stüdyosu dış izolasyonu, otel oda arası yalıtım ve
          yüksek gürültülü makine dairesi duvarları bariyerli bondex gerektirir. Sadece zemin darbesi veya
          makine altı titreşim varsa standart bondex yeterli olabilir. İnce kapı detaylarında{' '}
          <Link to="/bariyerli-bondex-sunger-23mm" rel="follow">
            Bariyerli Bondex Sünger 23mm
          </Link>{' '}
          tercih edilir. Maksimum izolasyon hedefinde{' '}
          <Link to="/cift-bariyerli-bondex-sunger-56mm" rel="follow">
            Çift Bariyerli Bondex 56mm
          </Link>{' '}
          değerlendirilir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Bondex Sünger Kalınlıkları ve Yoğunlukları</h2>

        <h3 className={styles.seoSubtitle}>10 mm Bondex Sünger</h3>
        <p className={styles.seoText}>
          En ince kalınlık olan 10 mm, yükseklik kaybının sınırlı olduğu detaylarda kullanılır. Kapı kasası
          dolgusu, ince bölme duvar, kaplama altı şap ve mobilya içi sönümleme bu gruba girer. Temel ses
          yalıtımı sağlar; yüksek izolasyon beklenmemelidir.{' '}
          <Link to="/bondex-sunger-10mm" rel="follow">
            Bondex Sünger 10mm
          </Link>{' '}
          fiyat ve stok bilgisi için Echopan ile iletişime geçilebilir.
        </p>
        <p className={styles.seoText}>
          10 mm kalınlık özellikle mevcut zemin yüksekliğini koruyarak şap altı uygulama yapılacak
          renovasyonlarda tercih edilir. Kapı eşiği ve banyo eşiği gibi geçiş noktalarında ince profil
          gerektiğinde de kullanılır. Darbe sönümlemesi sınırlıdır; yoğun ayak trafiği olan alanlarda
          daha kalın model seçilmelidir.
        </p>

        <h3 className={styles.seoSubtitle}>20 mm Bondex Sünger</h3>
        <p className={styles.seoText}>
          Performans ve yer tasarrufu dengesinde en popüler seçenektir. Konut duvarı, ofis bölmesi ve hafif
          makine odası uygulamalarında yeterli sönümleme sunar. DNS değeri proje ihtiyacına göre 120 ile 180
          kg/m³ arasında belirlenir.{' '}
          <Link to="/bondex-sunger-20mm" rel="follow">
            Bondex Sünger 20mm
          </Link>{' '}
          geniş stokla sunulur.
        </p>
        <p className={styles.seoText}>
          Yeni yapılan konutlarda ortak duvar ve tavan uygulamasında en sık tercih edilen kalınlıktır.
          Karkas derinliği 50-70 mm olan sistemlerde 20 mm levha rahatlıkla yerleşir. Hem darbe hem hafif
          hava yolu sesinde temel düzeyde iyileşme sağlar. Komşu konuşma sesi belirgin şekilde rahatsız
          ediyorsa 20 mm yeterli kalmayabilir; bu durumda bariyerli modele geçiş değerlendirilir.
        </p>

        <h3 className={styles.seoSubtitle}>30 mm Bondex Sünger</h3>
        <p className={styles.seoText}>
          Orta ve yüksek izolasyon gerektiren projelerde tercih edilir. Tavan altı, ortak duvar ve stüdyo
          zemininde sık kullanılır. 20 mm ile karşılaştırıldığında darbe sönümlemesi belirgin şekilde artar.
          Yükseklik kısıtı olan alanlarda bariyerli modele geçmeden önce değerlendirilmesi gereken kalınlıktır.{' '}
          <Link to="/bondex-sunger-30mm" rel="follow">
            Bondex Sünger 30mm
          </Link>{' '}
          teknik özellikleri ürün sayfasında yer alır.
        </p>
        <p className={styles.seoText}>
          Tavan uygulamasında 30 mm levha asma tavan karkası içine rahatlıkla yerleşir. Katlar arası ayak
          sesinde 20 mm yetersiz kaldığında bir üst kalınlık olarak tercih edilir. Stüdyo zemininde şap altı
          detayda 30 mm bondex sünger + şap + kaplama üçlüsü yaygın bir sistemdir. Duvar uygulamasında hacim
          kaybı kabul edilebilir düzeydeyse 30 mm güçlü bir darbe ve orta düzey hava yolu çözümüdür.
        </p>

        <h3 className={styles.seoSubtitle}>40 mm Bondex Sünger</h3>
        <p className={styles.seoText}>
          Yüksek performanslı projeler için üst segment kalınlıktır. Jeneratör odası zemin altı, spor salonu
          şap detayı ve yoğun darbe yükü olan zeminlerde tercih edilir. Duvar uygulamasında hacim kaybı
          artacağından proje başında planlanmalıdır. Hava yolu sesinde ek bariyer katmanı gerekebilir; bu
          durumda{' '}
          <Link to="/bondex-sunger-40mm" rel="follow">
            Bondex Sünger 40mm
          </Link>{' '}
          ile{' '}
          <Link to="/bariyerli-bondex-sunger-43mm" rel="follow">
            Bariyerli Bondex Sünger 43mm
          </Link>{' '}
          karşılaştırılmalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>50 mm Bondex Sünger</h3>
        <p className={styles.seoText}>
          Standart bondex serisinin en kalın modelidir. Maksimum sönümleme hedefleyen endüstriyel ve ticari
          projelerde kullanılır. Makine dairesi zemin altı, ağır darbe yükü ve yüksek titreşim ortamlarında
          tercih edilir. Hava kaynaklı ses problemi devam ediyorsa bariyerli veya çift bariyerli modellere
          geçiş yapılmalıdır.{' '}
          <Link to="/bondex-sunger-50mm" rel="follow">
            Bondex Sünger 50mm
          </Link>{' '}
          özel kesim ve proje bazlı tedarik edilebilir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Bondex Sünger Nasıl Uygulanır?</h2>

        <h3 className={styles.seoSubtitle}>Duvar Uygulaması</h3>
        <p className={styles.seoText}>
          Betonarme duvara doğrudan yapıştırma veya metal/ahşap karkas arasına yerleştirme yapılır. Yüzey kuru,
          temiz ve düzgün olmalıdır. Karkas sistemde levha karkas boşluğunu tamamen kaplayacak şekilde kesilir;
          üzerine alçıpan vidalanır. Levha ek yerleri en az 50 mm bindirmeli ve akustik bantla kapatılmalıdır.
          Priz, tesisat ve havalandırma boşlukları ses sızdıran zayıf noktalardır; bu detaylar kapatılmadan
          tam izolasyon beklenemez.
        </p>
        <p className={styles.seoText}>
          Doğrudan yapıştırmada beton yüzey düzgün değilse önce şap veya tesviye yapılmalıdır. Karkas
          sistemde profil duvara ankre edilir; profil ile duvar arasına ince bondex şeridi konularak titreşim
          köprüsü kırılır. Alçıpan vidalama noktaları ses sızdırmaz olmamalıdır; mümkünse alçıpan levha
          birbirine yapıştırılarak tek parça gibi çalıştırılır. İki kat alçıpan uygulaması tek kat alçıpana
          göre hava yolu sesinde ek fayda sağlar.
        </p>

        <h3 className={styles.seoSubtitle}>Tavan Uygulaması</h3>
        <p className={styles.seoText}>
          Asma tavan karkası veya doğrudan beton tavan altına yapıştırılarak uygulanır. Ağır levhalar için
          mekanik askı sistemi veya karkas desteği önerilir. Levha duvar birleşimine kadar uzatılmalı; tavan
          köşelerinde süreklilik sağlanmalıdır.{' '}
          <Link to="/bondex-sunger-30mm" rel="follow">
            Bondex Sünger 30mm
          </Link>{' '}
          tavan uygulamalarında en sık kullanılan kalınlıktır.
        </p>

        <h3 className={styles.seoSubtitle}>Zemin Uygulaması</h3>
        <p className={styles.seoText}>
          Bondex sünger şap altına serilir; üzerine şap ve kaplama malzemesi dökülür. Darbe sesini azaltmak için
          tüm zemin yüzeyi kesintisiz kaplanmalıdır. Kapı eşiği ve radyatör borusu geçişlerinde levha bölünmemeli;
          önceden kesim planı yapılmalıdır. İnce detaylarda{' '}
          <Link to="/bondex-sunger-10mm" rel="follow">
            Bondex Sünger 10mm
          </Link>{' '}
          şap yüksekliğini minimumda tutar.
        </p>
        <p className={styles.seoText}>
          Zemin uygulamasında levha üzerine ince bir seperatör veya streç film konulması şapın süngere yapışmasını
          engeller; bu detay uzun vadeli performans için önemlidir. Şap kalınlığı minimum 4 cm olmalıdır; çok ince
          şap levha üzerinde çatlayabilir. Isıtma sistemli zeminlerde bondex sünger ısı ile performans kaybetmez;
          ancak şap kuruma süresi standart uygulamaya göre uzayabilir.
        </p>

        <h3 className={styles.seoSubtitle}>Yapıştırıcı Seçimi ve Montaj Süreci</h3>
        <p className={styles.seoText}>
          Neopren bazlı contact adhesive veya PU köpük yapıştırıcı yaygın kullanılır. Nemli beton yüzeyde primer
          uygulanmalıdır. Yapıştırıcı tüm yüzeye homojen sürülür; levya yerleştirildikten sonra rulo ile hava
          kabarcıkları alınır. Montaj sonrası yapıştırıcının kuruması için 24 saat beklenmesi önerilir. Bariyerli
          modellerde bariyer yüzeyi ses kaynağına bakacak şekilde yerleştirilir;{' '}
          <Link to="/bariyerli-bondex-sunger-33mm" rel="follow">
            Bariyerli Bondex Sünger 33mm
          </Link>{' '}
          duvar uygulamalarında en dengeli seçenektir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Bondex Sünger Ses Yalıtımında Ne Kadar Etkilidir?</h2>
        <p className={styles.seoText}>
          Bondex sünger için tek bir desibel değeri vermek yanıltıcıdır. Performans, uygulama yapısının tamamına
          bağlıdır; levha tek başına ölçülmez. Laboratuvar testleri ile şantiye sonuçları arasında fark çıkması
          normaldir. Montaj kalitesi, ek yerleri, boşluklar ve kapı detayları sonucu doğrudan belirler.
        </p>

        <h3 className={styles.seoSubtitle}>Hava Doğuşumlu Seslerde Performansı</h3>
        <p className={styles.seoText}>
          Konuşma, televizyon, müzik ve klima gürültüsü hava yoluyla taşınır. Standart bondex sünger bu frekans
          bandında sınırlı kalır; lifli yapı sesi kısmen sönümler ancak geçişi tamamen engellemez. Hava yolu
          sesinde belirgin iyileşme için{' '}
          <Link to="/bariyerli-bondex-sunger" rel="follow">
            Bariyerli Bondex Sünger
          </Link>{' '}
          veya{' '}
          <Link to="/cift-bariyerli-bondex-sunger-36mm" rel="follow">
            Çift Bariyerli Bondex 36mm
          </Link>{' '}
          tercih edilmelidir. Orta frekanslarda bondex sünger fark yaratır; düşük frekanslı bas seslerde ek
          kalınlık veya bariyer katmanı gerekir.
        </p>
        <p className={styles.seoText}>
          Hava kaynaklı sesin geçişi kütle yasasına bağlıdır: hafif malzeme sesi geçirir, ağır ve esnek
          bariyer katmanı geçişi zorlaştırır. Bondex sünger tek başına kütle etkisi sunmaz; bu nedenle
          konuşma sesinde sınırlı kalır. Duvar sisteminde bondex sünger + alçıpan + karkas birlikte
          çalışır; ölçüm bu sistemin tamamında yapılır. Kapı ve pencere zayıf noktaları giderilmeden
          duvar izolasyonu artırılsa bile oda içi ses seviyesi düşmeyebilir.
        </p>

        <h3 className={styles.seoSubtitle}>Darbe Kaynaklı Seslerde Performansı</h3>
        <p className={styles.seoText}>
          Ayak sesi, düşen eşya ve makine titreşimi bondex süngerin güçlü olduğu alandır. Elastik rebonded
          yapı darbe enerjisini dağıtarak yapıya iletilen titreşimi azaltır. Zemin altı şap detayında{' '}
          <Link to="/bondex-sunger-40mm" rel="follow">
            Bondex Sünger 40mm
          </Link>{' '}
          veya 50 mm modeller belirgin fark sağlar. Darbe problemi tek başına varsa ve komşu konuşma sesi
          gelmiyorsa bariyerli modele geçmek zorunlu değildir.
        </p>

        <h3 className={styles.seoSubtitle}>Daha Yüksek Verim İçin Kombine Sistemler</h3>
        <p className={styles.seoText}>
          Tek malzeme ile maksimum izolasyon nadiren elde edilir. Bondex sünger; alçıpan, karkas, akustik bant
          ve bariyer katmanıyla birlikte sistem olarak çalışır. Kritik stüdyo ve makine odalarında çift karkas
          duvar, iki yüzeyde bariyerli levha ve süreksiz bağlantı detayları uygulanır.{' '}
          <Link to="/cift-bariyerli-bondex-sunger-46mm" rel="follow">
            Çift Bariyerli Bondex 46mm
          </Link>{' '}
          maksimum hava yolu kesimi hedefleyen projelerde değerlendirilir. Echopan proje bazlı katman planı
          hazırlayabilir.
        </p>
        <p className={styles.seoText}>
          Kombine sistemde her katman farklı frekans bandında çalışır: bariyer katmanı hava yolu sesini keser,
          bondex sünger titreşimi sönümler, alçıpan ek kütle sağlar. Karkas profili ile yapı arasında kauçuk
          conta kullanımı titreşim köprüsünü kırar. Çift karkas duvarlarda iki karkas birbirine bağlanmamalıdır;
          aralarında hava boşluğu bırakılarak yapısal bağlantı kesilir. Bu uygulama özellikle kayıt stüdyosu ve
          ev sinema odası projelerinde tercih edilir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Bondex Sünger Seçerken Nelere Dikkat Edilmelidir?</h2>

        <h3 className={styles.seoSubtitle}>DNS Yoğunluk Seçimi</h3>
        <p className={styles.seoText}>
          DNS değeri malzemenin sertliğini ve sönümleme kapasitesini belirler. Düşük DNS levhalar kolay ezilir,
          yüksek trafikli zeminlerde çöker. Yüksek DNS levhalar daha sert ve dayanıklıdır; makine altı ve şap
          altı uygulamalarda tercih edilir. Echopan stoklarında 120 ile 200 kg/m³ arası seçenekler bulunur.
          Uygulama alanı ve yük tipi DNS seçimini belirler.
        </p>
        <p className={styles.seoText}>
          DNS seçiminde yaygın hata, yalnızca fiyata bakarak düşük yoğunluklu levha almaktır. Şap altında
          veya makine altında düşük DNS levha kısa sürede sıkışır ve performans kaybeder. Duvar karkası
          içinde orta DNS levha yeterlidir; ağır yük beklenmiyorsa 120-150 kg/m³ aralığı ekonomik ve
          işlevsel bir seçimdir. Proje bazlı özel DNS talepleri Echopan üretim hattında karşılanabilir.
        </p>

        <h3 className={styles.seoSubtitle}>Uygulama Alanına Göre Kalınlık Belirleme</h3>
        <p className={styles.seoText}>
          İnce detay ve kaplama altı için 10 mm, dengeli konut uygulaması için 20 mm, tavan ve orta izolasyon
          için 30 mm, yüksek darbe yükü için 40-50 mm seçilir. Yükseklik kısıtı varsa kalınlık yerine bariyerli
          modele geçiş değerlendirilir. Yanlış kalınlık seçimi ya yetersiz performans ya da gereksiz maliyet
          demektir.{' '}
          <Link to="/bondex-sunger-20mm" rel="follow">
            Bondex Sünger 20mm
          </Link>{' '}
          çoğu konut projesi için başlangıç noktasıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Bariyerli ve Bariyersiz Ürün Tercihi</h3>
        <p className={styles.seoText}>
          Darbe ve titreşim ağırlıklı projelerde standart bondex yeterlidir. Komşu duvar ses geçişi, stüdyo
          dış izolasyonu ve yüksek gürültülü ticari alanlarda bariyerli bondex şarttır. İki ürün birbirinin
          üst modeli değil, farklı gürültü tiplerine karşı optimize edilmiş malzemelerdir. Kararsız kalındığında
          Echopan teknik ekibine uygulama detayları paylaşılarak doğru ürün belirlenir.{' '}
          <Link to="/bariyerli-bondex-sunger-53mm" rel="follow">
            Bariyerli Bondex Sünger 53mm
          </Link>{' '}
          maksimum hava yolu izolasyonu sunar.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Bondex Sünger Fiyatları</h2>

        <h3 className={styles.seoSubtitle}>Fiyatları Etkileyen Faktörler</h3>
        <p className={styles.seoText}>
          Bondex sünger fiyatı; kalınlık, DNS yoğunluğu, sipariş metrajı, plaka ölçüsü ve teslimat noktasına
          göre değişir. Büyük projelerde metraj indirimi uygulanabilir. Özel kesim ve proje bazlı üretim birim
          maliyeti etkiler. Güncel fiyat için uygulama alanı, hedef kalınlık ve metraj bilgisi paylaşılmalıdır.
          Echopan WhatsApp hattı üzerinden hızlı teklif sunar.
        </p>
        <p className={styles.seoText}>
          Fiyat karşılaştırması yapılırken yalnızca metrekare birim fiyatına bakmak yanıltıcı olabilir. Düşük
          DNS veya yanlış kalınlık seçimi, uygulama sonrası yeniden müdahale gerektirebilir; bu da toplam
          maliyeti artırır. Doğru ürün seçimi baştan yapıldığında bondex sünger uzun vadede ekonomik bir
          yatırımdır. Kargo ve teslimat maliyeti sipariş hacmine göre değişir; büyük projelerde araç
          teslimatı daha verimli olabilir.
        </p>

        <h3 className={styles.seoSubtitle}>Kalınlığa Göre Bondex Sünger Fiyatları</h3>
        <p className={styles.seoText}>
          Kalınlık arttıkça birim fiyat yükselir; ancak metrekare başına sönümleme kapasitesi de artar. 10 mm
          en ekonomik giriş seviyesidir; 50 mm en yüksek birim fiyatlı standart modeldir. Proje bütçesi
          planlanırken yalnızca levha fiyatı değil, yapıştırıcı, bant ve işçilik de hesaba katılmalıdır.{' '}
          <Link to="/bondex-sunger-10mm" rel="follow">
            Bondex Sünger 10mm
          </Link>
          ,{' '}
          <Link to="/bondex-sunger-30mm" rel="follow">
            Bondex Sünger 30mm
          </Link>{' '}
          ve{' '}
          <Link to="/bondex-sunger-50mm" rel="follow">
            Bondex Sünger 50mm
          </Link>{' '}
          için ayrı teklif alınabilir.
        </p>

        <h3 className={styles.seoSubtitle}>Bariyerli Bondex Sünger Fiyatları</h3>
        <p className={styles.seoText}>
          Bariyer katmanı nedeniyle bariyerli modeller standart bondexe göre daha yüksek birim fiyata sahiptir.
          Ancak ayrı bariyer levhası ve sünger satın almaya kıyasla montaj süresi kısalır ve sistem uyumu artar.
          Toplam proje maliyetinde bariyerli bondex çoğu zaman daha verimli çıkar.{' '}
          <Link to="/bariyerli-bondex-sunger-23mm" rel="follow">
            Bariyerli Bondex Sünger 23mm
          </Link>{' '}
          ile{' '}
          <Link to="/bariyerli-bondex-sunger-53mm" rel="follow">
            Bariyerli Bondex Sünger 53mm
          </Link>{' '}
          arası tüm kalınlıklar için Echopan fiyat teklifi verir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Echopan Bondex Sünger Çözümleri</h2>

        <h3 className={styles.seoSubtitle}>Echopan Bondex Sünger Ürün Seçenekleri</h3>
        <p className={styles.seoText}>
          Echopan; 10 ile 50 mm arası standart bondex sünger, 23 ile 53 mm arası bariyerli bondex ve 26 ile 56 mm
          arası çift bariyerli bondex modellerini stoktan ve proje bazlı tedarik eder. Tüm ürünler kontrollü DNS
          değerinde, düzgün kesimli plaka halinde sunulur.{' '}
          <Link to="/bondex-sunger-20mm" rel="follow">
            Bondex Sünger 20mm
          </Link>
          ,{' '}
          <Link to="/bariyerli-bondex-sunger-33mm" rel="follow">
            Bariyerli Bondex Sünger 33mm
          </Link>{' '}
          ve{' '}
          <Link to="/cift-bariyerli-bondex-sunger-26mm" rel="follow">
            Çift Bariyerli Bondex 26mm
          </Link>{' '}
          en çok talep edilen modellerdir.
        </p>

        <h3 className={styles.seoSubtitle}>Projelere Özel Üretim İmkânı</h3>
        <p className={styles.seoText}>
          Standart plaka ölçüleri dışında özel ebat, farklı DNS değeri ve proje bazlı kesim talepleri
          karşılanabilir. Otel, hastane, stüdyo ve endüstriyel tesis projelerinde teknik ekibimiz katman planı
          ve malzeme listesi hazırlar. Numune gönderimi ve saha ziyareti büyük projelerde mümkündür. Özel üretim
          süresi sipariş hacmine göre 3 ile 10 iş günü arasında değişir.
        </p>
        <p className={styles.seoText}>
          Özel üretim taleplerinde proje çizimleri ve metraj listesi paylaşılmalıdır. Echopan teknik ekibi
          uygulama detaylarına göre kalınlık, DNS ve ürün tipi önerir. Büyük projelerde parti parti teslimat
          planlanabilir; bu sayede şantiyede depolama sorunu yaşanmaz. İhracat talepleri için ambalaj ve
          lojistik ayrıca organize edilir.
        </p>

        <h3 className={styles.seoSubtitle}>Teklif ve Sipariş Süreci</h3>
        <p className={styles.seoText}>
          Teklif almak için uygulama alanı (metraj), hedef kalınlık, bariyerli veya standart tercihi ve teslimat
          adresi paylaşılmalıdır. Echopan aynı gün içinde fiyat teklifi ve stok durumu bildirir. Onay sonrası
          ödeme ve sevkiyat planlanır; Türkiye geneline kargo ve büyük siparişlerde araç teslimatı yapılır.
          Montaj desteği ve teknik danışmanlık için WhatsApp hattımızdan ulaşabilirsiniz.
        </p>
      </section>
    </div>
  );
}
